import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateTime } from 'luxon';
import { AppValidators } from 'src/app/common/appValidators';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { DataLayerFiltersModel } from 'src/app/models/filters/implementations/pageFilters/dataLayerFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';

@Component({
  selector: 'app-data-layer-filters',
  templateUrl: './data-layer-filters.component.html',
  styleUrls: ['./data-layer-filters.component.scss'],
})
export class DataLayerFiltersComponent implements OnInit {
  @Input() public pageFilters: DataLayerFiltersModel;

  public selectedOptions: ISelectOption[] = [];
  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public fromDateNewValue = new ReplaySubject<Date | undefined>(1);
  public toDateNewValue = new ReplaySubject<Date | undefined>(1);
  public searchValidators = [AppValidators.evenNumberOfQuoteMarks];
  public minDate = DateTime.now().minus({ months: 3 }).toJSDate();

  constructor(private readonly _destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();
      this.searchBoxNewValue.next(data.search);
      this.fromDateNewValue.next(data.fromDate);
      this.toDateNewValue.next(data.toDate);
    });
  }

  public fromDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FromDate, value);
  }

  public toDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.ToDate, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }
}
